import { broadcastMessageReviewService } from "../services/broadcastMessageReview.service";
import { broadcastMessageReviewConstants } from "../constants/broadcastMessageReview.constants";

export const broadcastMessageReviewActions = {
  get,
  create,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    broadcastMessageReviewService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: broadcastMessageReviewConstants.GET_BROADCAST_MESSAGE_REVIEW_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: broadcastMessageReviewConstants.GET_BROADCAST_MESSAGE_REVIEW_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return {
      type: broadcastMessageReviewConstants.GET_BROADCAST_MESSAGE_REVIEW_FAILURE,
    };
  }
}

function create(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    broadcastMessageReviewService.create(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: broadcastMessageReviewConstants.CREATE_BROADCAST_MESSAGE_REVIEW_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return {
      type: broadcastMessageReviewConstants.CREATE_BROADCAST_MESSAGE_REVIEW_SUCCESS,
    };
  }
  function failure() {
    return {
      type: broadcastMessageReviewConstants.CREATE_BROADCAST_MESSAGE_REVIEW_FAILURE,
    };
  }
}
